import React from 'react';
import { motion } from 'framer-motion';
import { ShieldIcon, ZapIcon, TargetIcon, UserIcon } from 'lucide-react';
const benefits = [{
  title: 'Dominio Total',
  desc: 'Recupera el mando sobre tus manos y tus ojos. No más recaídas humillantes.',
  icon: ShieldIcon
}, {
  title: 'Energía de Titán',
  desc: 'Despierta con una claridad mental que no sentías desde hace años.',
  icon: ZapIcon
}, {
  title: 'Foco de Combate',
  desc: 'Destruye la pereza y termina en horas lo que antes te tomaba días.',
  icon: TargetIcon
}, {
  title: 'Presencia Masculina',
  desc: 'Reconstruye tu confianza al saber que eres un hombre que cumple lo que dice.',
  icon: UserIcon
}];
export function BenefitsSection() {
  return <section className="py-12 sm:py-16 lg:py-24 relative bg-dark-surface border-y border-dark-border" data-id="element-1">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} className="text-center mb-10 sm:mb-16" data-id="element-3">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-4" data-id="element-4">
            QUÉ VAS A <span className="text-gold" data-id="element-5">LOGRAR</span>
          </h2>
          <div className="w-24 h-[1px] bg-gold/50 mx-auto" data-id="element-6" />
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-4 sm:gap-6 lg:gap-8" data-id="element-7">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="group bg-dark-card border border-dark-border p-5 sm:p-6 lg:p-8 rounded-sm hover:border-gold/50 transition-all duration-300 relative overflow-hidden" data-id="element-8">
              {/* Hover glow effect */}
              <div className="absolute inset-0 bg-gold/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" data-id="element-9" />

              <div className="flex items-start gap-4 sm:gap-6 relative z-10" data-id="element-10">
                <div className="p-3 sm:p-4 bg-dark-bg rounded-lg border border-dark-border group-hover:border-gold/30 group-hover:text-gold text-gray-400 transition-colors duration-300 shrink-0" data-id="element-11">
                  <benefit.icon className="w-6 h-6 sm:w-8 sm:h-8" data-id="element-12" />
                </div>
                <div data-id="element-13">
                  <h3 className="text-lg sm:text-xl font-bold text-white mb-1.5 sm:mb-2 font-cinzel tracking-wide" data-id="element-14">
                    {benefit.title}
                  </h3>
                  <p className="text-sm sm:text-base text-gray-400 leading-relaxed" data-id="element-15">
                    {benefit.desc}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}